import React, { createContext, useContext, useState, useCallback } from 'react';

const CartContext = createContext();

export const useCart = () => useContext(CartContext);

export const CartProvider = ({ children }) => {
    const [cartItems, setCartItems] = useState([]);

    const addToCart = (serviceItem) => {
        // serviceItem would be an object like { id, title, serviceId, postId, price, ... }
        setCartItems(prevItems => [...prevItems, { ...serviceItem, cartId: Date.now() }]);
    };

    const removeFromCart = (cartId) => {
        setCartItems(prevItems => prevItems.filter(item => item.cartId !== cartId));
    };

    const clearCart = () => {
        setCartItems([]);
    };

    // Helper for the "smart cart" logic
    const getPostInCart = () => {
        if (cartItems.length > 0) {
            // Return the postId from the first item, assuming it's the context for the package
            return cartItems[0].postId; 
        }
        return null;
    };

    const getSongInCart = useCallback(() => {
        const songItem = cartItems.find(item => item.songId);
        return songItem ? songItem.songId : null;
    }, [cartItems]);

    const value = { cartItems, addToCart, removeFromCart, clearCart, getPostInCart, getSongInCart };

    return (
        <CartContext.Provider value={value}>
            {children}
        </CartContext.Provider>
    );
};